(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQS"] && !Shopify.designMode) return;
  try {
    
  (function() {
    class AcordeonFaqs {
      constructor(seccion) {
        this.seccion = seccion;
        this.items = Array.from(seccion.querySelectorAll('[data-faq]'));
        this.permitirMultiple = seccion.dataset.permitirMultiple === 'true';

        if (this.items.length === 0) return;

        this.init();
      }

      init() {
        this.items.forEach((item) => {
          const toggle = item.querySelector('[data-faq-toggle]');
          const contenido = item.querySelector('[data-faq-contenido]');

          if (!toggle || !contenido) return;

          toggle.addEventListener('click', () => {
            const estaAbierto = toggle.getAttribute('aria-expanded') === 'true';

            if (estaAbierto) {
              this.cerrar(item);
            } else {
              if (!this.permitirMultiple) {
                this.items.forEach((otro) => {
                  if (otro !== item) this.cerrar(otro);
                });
              }
              this.abrir(item);
            }
          });
        });
      }

      abrir(item) {
        const toggle = item.querySelector('[data-faq-toggle]');
        const contenido = item.querySelector('[data-faq-contenido]');
        if (!toggle || !contenido) return;

        toggle.setAttribute('aria-expanded', 'true');
        contenido.removeAttribute('hidden');
      }

      cerrar(item) {
        const toggle = item.querySelector('[data-faq-toggle]');
        const contenido = item.querySelector('[data-faq-contenido]');
        if (!toggle || !contenido) return;

        toggle.setAttribute('aria-expanded', 'false');
        contenido.setAttribute('hidden', '');
      }
    }

    function inicializar() {
      document.querySelectorAll('.seccion-faqs').forEach((seccion) => {
        if (!seccion.dataset.inicializado) {
          new AcordeonFaqs(seccion);
          seccion.dataset.inicializado = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const seccion = e.target.querySelector('.seccion-faqs');
      if (seccion && !seccion.dataset.inicializado) {
        new AcordeonFaqs(seccion);
        seccion.dataset.inicializado = 'true';
      }
    });

    document.addEventListener('shopify:block:select', (e) => {
      const item = e.target.closest('[data-faq]');
      if (!item) return;
      const toggle = item.querySelector('[data-faq-toggle]');
      if (toggle && toggle.getAttribute('aria-expanded') === 'false') {
        toggle.click();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-testimonios"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class HairBondStories {
      constructor(section) {
        this.section = section;
        this.viewport = section.querySelector('[data-viewport]');
        this.track = section.querySelector('[data-track]');
        this.slides = [...section.querySelectorAll('[data-slide]')];
        this.dots = [...section.querySelectorAll('[data-dot]')];
        this.prev = section.querySelector('[data-prev]');
        this.next = section.querySelector('[data-next]');

        if (!this.viewport || !this.track || !this.slides.length) return;

        this.current = 0;
        this.autoplay = section.dataset.autoplay === 'true';
        this.delay = Math.max(3, Number(section.dataset.autoplaySeconds) || 6) * 1000;
        this.timer = null;
        this.raf = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.init();
      }

      init() {
        if (this.slides.length <= 1) {
          if (this.prev) this.prev.hidden = true;
          if (this.next) this.next.hidden = true;
          this.dots.forEach((dot) => dot.hidden = true);
        }

        this.prev?.addEventListener('click', () => { this.goTo(this.current - 1); this.restartAutoplay(); });
        this.next?.addEventListener('click', () => { this.goTo(this.current + 1); this.restartAutoplay(); });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(Number(dot.dataset.index));
            this.restartAutoplay();
          });
        });

        this.viewport.addEventListener('scroll', () => {
          if (this.raf) cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.syncFromScroll());
        }, { passive: true });

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.current - 1);
            this.restartAutoplay();
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.current + 1);
            this.restartAutoplay();
          }
        });

        ['mouseenter', 'focusin', 'pointerdown'].forEach((name) => {
          this.section.addEventListener(name, () => this.stopAutoplay(), { passive: true });
        });

        ['mouseleave', 'focusout', 'pointerup', 'pointercancel'].forEach((name) => {
          this.section.addEventListener(name, () => this.startAutoplay(), { passive: true });
        });

        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stopAutoplay() : this.startAutoplay();
        });

        this.updateControls();
        this.startAutoplay();
      }

      normalize(index) {
        if (index < 0) return this.slides.length - 1;
        if (index >= this.slides.length) return 0;
        return index;
      }

      goTo(index, smooth = true) {
        const nextIndex = this.normalize(index);
        const slide = this.slides[nextIndex];
        this.current = nextIndex;
        this.updateControls();

        this.viewport.scrollTo({
          left: slide.offsetLeft - this.track.offsetLeft,
          behavior: smooth && !this.reducedMotion ? 'smooth' : 'auto'
        });
      }

      syncFromScroll() {
        const viewportCenter = this.viewport.scrollLeft + (this.viewport.clientWidth / 2);
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft - this.track.offsetLeft + (slide.offsetWidth / 2);
          const distance = Math.abs(viewportCenter - slideCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== this.current) {
          this.current = closestIndex;
          this.updateControls();
        }
      }

      updateControls() {
        this.dots.forEach((dot, index) => {
          const active = index === this.current;
          dot.classList.toggle('is-active', active);
          active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
        });
      }

      startAutoplay() {
        if (!this.autoplay || this.reducedMotion || document.hidden || this.slides.length <= 1) return;
        this.stopAutoplay();
        this.timer = window.setTimeout(() => {
          this.goTo(this.current + 1);
          this.startAutoplay();
        }, this.delay);
      }

      stopAutoplay() {
        if (!this.timer) return;
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    const init = (root = document) => {
      root.querySelectorAll('[data-hb-stories]').forEach((section) => {
        if (section.dataset.hbInitialized === 'true') return;
        new HairBondStories(section);
        section.dataset.hbInitialized = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paso-paso"] && !Shopify.designMode) return;
  try {
    
  (function() {
    class PasosTimeline {
      constructor(seccion) {
        this.seccion = seccion;
        this.pasos = Array.from(seccion.querySelectorAll('[data-paso]'));
        this.imagenesDesktop = Array.from(seccion.querySelectorAll('[data-imagen-desktop]'));

        if (this.pasos.length === 0) return;

        this.indiceActivo = 0;
        this.init();
      }

      init() {
        this.pasos.forEach((paso) => {
          const cabecera = paso.querySelector('[data-cabecera]');
          if (!cabecera) return;

          cabecera.addEventListener('click', () => {
            const indice = parseInt(paso.dataset.indice, 10);
            this.activar(indice);
          });
        });
      }

      activar(indice) {
        if (indice === this.indiceActivo) return;

        this.pasos.forEach((paso, i) => {
          const contenido = paso.querySelector('[data-contenido]');
          const cabecera = paso.querySelector('[data-cabecera]');

          if (i === indice) {
            paso.classList.add('is-active');
            if (cabecera) cabecera.setAttribute('aria-expanded', 'true');
            if (contenido) contenido.removeAttribute('hidden');
          } else {
            paso.classList.remove('is-active');
            if (cabecera) cabecera.setAttribute('aria-expanded', 'false');
            if (contenido) contenido.setAttribute('hidden', '');
          }
        });

        this.imagenesDesktop.forEach((imagen, i) => {
          if (i === indice) {
            imagen.classList.add('is-active');
            imagen.setAttribute('aria-hidden', 'false');
          } else {
            imagen.classList.remove('is-active');
            imagen.setAttribute('aria-hidden', 'true');
          }
        });

        this.indiceActivo = indice;
      }
    }

    function inicializar() {
      document.querySelectorAll('.seccion-pasos-timeline').forEach((seccion) => {
        if (!seccion.dataset.inicializado) {
          new PasosTimeline(seccion);
          seccion.dataset.inicializado = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const seccion = e.target.querySelector('.seccion-pasos-timeline');
      if (seccion && !seccion.dataset.inicializado) {
        new PasosTimeline(seccion);
        seccion.dataset.inicializado = 'true';
      }
    });

    document.addEventListener('shopify:block:select', (e) => {
      const paso = e.target.closest('[data-paso]');
      if (!paso) return;
      const seccion = paso.closest('.seccion-pasos-timeline');
      if (!seccion) return;
      const indice = parseInt(paso.dataset.indice, 10);
      const cabecera = paso.querySelector('[data-cabecera]');
      if (cabecera) cabecera.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reloj"] && !Shopify.designMode) return;
  try {
    
  (function() {
    class ContadorOferta {
      constructor(elemento) {
        this.elemento = elemento;
        this.horasEl = elemento.querySelector('[data-horas]');
        this.minutosEl = elemento.querySelector('[data-minutos]');
        this.segundosEl = elemento.querySelector('[data-segundos]');

        this.duracionHoras = parseFloat(elemento.dataset.duracionHoras) || 3;
        this.duracionMs = this.duracionHoras * 60 * 60 * 1000;
        this.storageKey = elemento.dataset.storageKey || 'bloom-contador-oferta';

        this.timer = null;
        this.altoAplicado = 0;
        this.actualizarPosicion = this.actualizarPosicion.bind(this);

        this.init();
      }

      init() {
        let finalizaEn = this.leerStorage();

        if (!finalizaEn || finalizaEn <= Date.now()) {
          finalizaEn = Date.now() + this.duracionMs;
          this.guardarStorage(finalizaEn);
        }

        this.finalizaEn = finalizaEn;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);

        this.actualizarPosicion();
        window.addEventListener('resize', this.actualizarPosicion);
        window.addEventListener('scroll', this.actualizarPosicion, { passive: true });
        window.addEventListener('load', this.actualizarPosicion);

        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(this.actualizarPosicion);
          this.resizeObserver.observe(this.elemento);
        }

        setTimeout(this.actualizarPosicion, 50);
        setTimeout(this.actualizarPosicion, 200);
        setTimeout(this.actualizarPosicion, 500);
        setTimeout(this.actualizarPosicion, 1000);
        setTimeout(this.actualizarPosicion, 2000);
      }

      encontrarHeader() {
        const selectores = [
          '.shopify-section-group-header-group',
          'header-component',
          '.header-section',
          '#header-component',
          'header.header'
        ];
        for (const sel of selectores) {
          const el = document.querySelector(sel);
          if (el) return el;
        }
        return null;
      }

      actualizarPosicion() {
        const header = this.encontrarHeader();
        let topHeader = 0;
        let altoHeader = 0;

        if (header) {
          const rect = header.getBoundingClientRect();
          altoHeader = rect.height;
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            topHeader = Math.max(0, rect.bottom);
          }
        }

        this.elemento.style.top = topHeader + 'px';

        const altoContador = this.elemento.getBoundingClientRect().height;

        if (altoContador > 0 && altoContador !== this.altoAplicado) {
          this.altoAplicado = altoContador;
          document.documentElement.style.setProperty('--contador-altura', altoContador + 'px');
          this.aplicarEspacio(altoContador);
        }
      }

      aplicarEspacio(alto) {
        const styleId = 'contador-oferta-espacio-style';
        let styleEl = document.getElementById(styleId);
        if (!styleEl) {
          styleEl = document.createElement('style');
          styleEl.id = styleId;
          document.head.appendChild(styleEl);
        }
        styleEl.textContent =
          '.shopify-section-group-header-group { margin-top: ' + alto + 'px !important; }';
      }

      leerStorage() {
        try {
          const valor = window.sessionStorage.getItem(this.storageKey);
          if (valor) {
            const parseado = parseInt(valor, 10);
            if (!isNaN(parseado)) return parseado;
          }
        } catch (e) {}
        return null;
      }

      guardarStorage(timestamp) {
        try {
          window.sessionStorage.setItem(this.storageKey, String(timestamp));
        } catch (e) {}
      }

      tick() {
        let restante = this.finalizaEn - Date.now();

        if (restante <= 0) {
          this.finalizaEn = Date.now() + this.duracionMs;
          this.guardarStorage(this.finalizaEn);
          restante = this.duracionMs;
        }

        const totalSegundos = Math.floor(restante / 1000);
        const horas = Math.floor(totalSegundos / 3600);
        const minutos = Math.floor((totalSegundos % 3600) / 60);
        const segundos = totalSegundos % 60;

        if (this.horasEl) this.horasEl.textContent = this.pad(horas);
        if (this.minutosEl) this.minutosEl.textContent = this.pad(minutos);
        if (this.segundosEl) this.segundosEl.textContent = this.pad(segundos);
      }

      pad(n) {
        return n < 10 ? '0' + n : String(n);
      }
    }

    function inicializar() {
      document.querySelectorAll('[data-contador-oferta]').forEach((el) => {
        if (!el.dataset.inicializado) {
          new ContadorOferta(el);
          el.dataset.inicializado = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const el = e.target.querySelector('[data-contador-oferta]');
      if (el && !el.dataset.inicializado) {
        new ContadorOferta(el);
        el.dataset.inicializado = 'true';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-testimonios"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function inicializarVideo(tarjeta, autoplayHabilitado) {
      var wrap = tarjeta.querySelector('[data-video-wrap]');
      var video = tarjeta.querySelector('[data-video]');
      var poster = tarjeta.querySelector('[data-poster]');
      var botonSonido = tarjeta.querySelector('[data-boton-sonido]');
      var botonPlay = tarjeta.querySelector('[data-play-button]');

      if (!video || !wrap) return;

      function marcarReproduciendo() {
        wrap.classList.add('is-playing');
        if (poster) poster.style.setProperty('opacity', '0', 'important');
      }

      function marcarPausado() {
        wrap.classList.remove('is-playing');
        if (poster) poster.style.setProperty('opacity', '1', 'important');
      }

      video.addEventListener('play', marcarReproduciendo);
      video.addEventListener('playing', marcarReproduciendo);
      video.addEventListener('pause', marcarPausado);
      video.addEventListener('ended', marcarPausado);

      function alternarReproduccion() {
        if (video.paused) {
          var promesa = video.play();
          if (promesa && typeof promesa.catch === 'function') {
            promesa.catch(function() {});
          }
        } else {
          video.pause();
        }
      }

      wrap.addEventListener('click', function(e) {
        if (botonSonido && botonSonido.contains(e.target)) return;
        alternarReproduccion();
      });

      if (botonPlay) {
        botonPlay.addEventListener('click', function(e) {
          e.stopPropagation();
          alternarReproduccion();
        });
      }

      if (botonSonido) {
        var iconoMute = botonSonido.querySelector('.videos-testimonios__icono-mute');
        var iconoUnmute = botonSonido.querySelector('.videos-testimonios__icono-unmute');

        botonSonido.addEventListener('click', function(e) {
          e.stopPropagation();
          video.muted = !video.muted;

          if (video.muted) {
            if (iconoMute) iconoMute.hidden = false;
            if (iconoUnmute) iconoUnmute.hidden = true;
            botonSonido.setAttribute('aria-label', 'Activar sonido');
          } else {
            if (iconoMute) iconoMute.hidden = true;
            if (iconoUnmute) iconoUnmute.hidden = false;
            botonSonido.setAttribute('aria-label', 'Silenciar');
          }
        });
      }

      if (autoplayHabilitado && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entradas) {
          entradas.forEach(function(entrada) {
            if (entrada.isIntersecting) {
              if (video.paused) {
                var promesa = video.play();
                if (promesa && typeof promesa.catch === 'function') {
                  promesa.catch(function() {});
                }
              }
            } else {
              if (!video.paused) {
                video.pause();
              }
            }
          });
        }, { threshold: 0.5 });

        observer.observe(video);
      }
    }

    function inicializarCarrusel(seccion) {
      var grid = seccion.querySelector('[data-grid]');
      var dots = Array.from(seccion.querySelectorAll('[data-dot]'));
      var tarjetas = Array.from(seccion.querySelectorAll('[data-video-tarjeta]'));

      if (!grid || dots.length === 0 || tarjetas.length === 0) return;

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var indice = parseInt(dot.dataset.indice, 10);
          var objetivo = tarjetas[indice];
          if (objetivo) {
            objetivo.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      });

      if ('IntersectionObserver' in window) {
        var observerCarrusel = new IntersectionObserver(function(entradas) {
          entradas.forEach(function(entrada) {
            if (entrada.isIntersecting) {
              var indice = tarjetas.indexOf(entrada.target);
              dots.forEach(function(d, i) {
                if (i === indice) {
                  d.classList.add('is-active');
                  d.setAttribute('aria-current', 'true');
                } else {
                  d.classList.remove('is-active');
                  d.removeAttribute('aria-current');
                }
              });
            }
          });
        }, { root: grid, threshold: 0.6 });

        tarjetas.forEach(function(tarjeta) {
          observerCarrusel.observe(tarjeta);
        });
      }
    }

    function inicializar(contenedor) {
      contenedor.querySelectorAll('.seccion-videos-testimonios').forEach(function(seccion) {
        if (seccion.dataset.inicializado) return;

        var autoplayHabilitado = seccion.dataset.autoplay === 'true';
        var tarjetas = seccion.querySelectorAll('[data-video-tarjeta]');

        tarjetas.forEach(function(tarjeta) {
          inicializarVideo(tarjeta, autoplayHabilitado);
        });

        inicializarCarrusel(seccion);
        seccion.dataset.inicializado = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        inicializar(document);
      });
    } else {
      inicializar(document);
    }

    document.addEventListener('shopify:section:load', function(e) {
      inicializar(e.target);
    });

    document.addEventListener('shopify:block:select', function(e) {
      var tarjeta = e.target.closest('[data-video-tarjeta]');
      if (!tarjeta) return;
      tarjeta.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
